import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { Button } from '../components/ui/button';
import { services } from '../mock';

export const Services = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 text-white py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Immigration Legal Services
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Comprehensive legal solutions for all your immigration needs. We're here to guide you through every step of the process.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="space-y-16">
            {services.map((service, index) => {
              const IconComponent = Icons[service.icon];
              const isEven = index % 2 === 0;

              return (
                <div
                  key={service.id}
                  className={`flex flex-col ${
                    isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } gap-8 items-center bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300`}
                >
                  {/* Image */}
                  <div className="w-full lg:w-1/2 h-80 lg:h-96 relative overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 to-transparent"></div>
                  </div>

                  {/* Content */}
                  <div className="w-full lg:w-1/2 p-8 lg:p-12">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="bg-gold-100 p-3 rounded-lg">
                        <IconComponent className="w-6 h-6 text-gold-600" />
                      </div>
                      <h2 className="text-3xl font-bold text-navy-900">
                        {service.title}
                      </h2>
                    </div>

                    <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                      {service.description}
                    </p>

                    <div className="space-y-3 mb-8">
                      <p className="text-sm font-semibold text-navy-800 uppercase tracking-wide">
                        What We Help With:
                      </p>
                      <ul className="space-y-2">
                        {service.details.map((detail, idx) => (
                          <li key={idx} className="flex items-start space-x-3">
                            <Icons.CheckCircle className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" />
                            <span className="text-gray-700">{detail}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <Link to="/contact">
                      <Button className="bg-gradient-to-r from-navy-700 to-navy-900 hover:from-navy-800 hover:to-navy-950 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
                        Get Started
                        <Icons.ArrowRight className="ml-2 w-5 h-5" />
                      </Button>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-navy-900 to-navy-800 text-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Not Sure Which Service You Need?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Schedule a consultation and we'll help you determine the best path forward for your immigration case.
            </p>
            <Link to="/contact">
              <Button className="bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-600 hover:to-gold-700 text-navy-900 px-10 py-6 text-lg font-bold rounded-xl shadow-2xl hover:shadow-gold-500/50 transition-all duration-300 hover:scale-105">
                Schedule Consultation
                <Icons.ArrowRight className="ml-2 w-6 h-6" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
